var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('custom-timeline')],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('custom-timeline-card')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('timeline-with-icons')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }